import React from "react";
import { Helmet } from "react-helmet";
import useAuth from "../hooks/useAuth";

const Title = ({ title, show }) => {
  const { currentUser } = useAuth();
  return (
    <Helmet>
      <title>
        {title}{" "}
        {show
          ? ""
          : currentUser
          ? ` | ${currentUser?.organization?.first_name} ${currentUser?.organization?.last_name}`
          : " | Trip Merchant"}
      </title>
    </Helmet>
  );
};

export default Title;
